// extracted by mini-css-extract-plugin
module.exports = {"vibrationAnimation":"haptic-card_vibrationAnimation__mcYI3","shakeAfterDelay":"haptic-card_shakeAfterDelay__e6vNo"};